import { render, staticRenderFns } from "./product-item-details.vue?vue&type=template&id=34875570&scoped=true&"
import script from "./product-item-details.vue?vue&type=script&lang=js&"
export * from "./product-item-details.vue?vue&type=script&lang=js&"
import style0 from "./product-item-details.vue?vue&type=style&index=0&id=34875570&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34875570",
  null
  
)

export default component.exports